import { atom } from 'jotai';
import type { SetStateAction } from 'react';
import { resolveSetStateAction } from './setStateAction';

/**
 * A writable atom that hands every written value to `persist`, so state can be
 * mirrored into browser storage. The initial value is not persisted, only
 * values written afterwards. Accepts a value or an updater function, like a
 * `useState` setter.
 */
export const atomWithPersistence = <Value>(
  initialValue: Value,
  persist: (value: Value) => void,
) => {
  const valueAtom = atom(initialValue);

  return atom(
    (get) => get(valueAtom),
    (get, set, update: SetStateAction<Value>) => {
      const nextValue = resolveSetStateAction(update, get(valueAtom));
      set(valueAtom, nextValue);
      persist(nextValue);
    },
  );
};
